// Vertical Thumbnail Slider for Product Gallery
if (!customElements.get('vertical-thumbnail-slider')) {
  customElements.define(
    'vertical-thumbnail-slider',
    class VerticalThumbnailSlider extends HTMLElement {
      constructor() {
        super();
        this.slider = this.querySelector('.thumbnail-list--vertical');
        this.prevButton = this.querySelector('.slider-button--prev');
        this.nextButton = this.querySelector('.slider-button--next');
        this.thumbnails = this.querySelectorAll('.thumbnail-list__item');
        
        if (!this.slider || !this.prevButton || !this.nextButton) return;
        
        this.scrollAmount = 100; // pixels to scroll per click
        this.init();
      }

      init() {
        this.prevButton.addEventListener('click', this.scrollUp.bind(this));
        this.nextButton.addEventListener('click', this.scrollDown.bind(this));
        this.slider.addEventListener('scroll', this.updateButtonVisibility.bind(this));
        
        // Initial button state
        this.updateButtonVisibility();
        
        // Show buttons on hover
        this.addEventListener('mouseenter', () => this.showButtons());
        this.addEventListener('mouseleave', () => this.hideButtons());
      }

      scrollUp(e) {
        e.preventDefault();
        this.slider.scrollBy({
          top: -this.scrollAmount,
          behavior: 'smooth'
        });
      }

      scrollDown(e) {
        e.preventDefault();
        this.slider.scrollBy({
          top: this.scrollAmount,
          behavior: 'smooth'
        });
      }

      updateButtonVisibility() {
        const atTop = this.slider.scrollTop <= 0;
        const atBottom = this.slider.scrollTop + this.slider.clientHeight >= this.slider.scrollHeight - 1;
        
        this.prevButton.style.display = atTop ? 'none' : 'flex';
        this.nextButton.style.display = atBottom ? 'none' : 'flex';
      }

      showButtons() {
        const atTop = this.slider.scrollTop <= 0;
        const atBottom = this.slider.scrollTop + this.slider.clientHeight >= this.slider.scrollHeight - 1;
        
        if (!atTop) this.prevButton.style.opacity = '1';
        if (!atBottom) this.nextButton.style.opacity = '1';
      }

      hideButtons() {
        this.prevButton.style.opacity = '0';
        this.nextButton.style.opacity = '0';
      }

      scrollToThumbnail(thumbnail) {
        if (!thumbnail) return;
        
        const thumbnailTop = thumbnail.offsetTop;
        const thumbnailHeight = thumbnail.offsetHeight;
        const sliderHeight = this.slider.clientHeight;
        const scrollTop = this.slider.scrollTop;
        
        // Check if thumbnail is not fully visible
        if (thumbnailTop < scrollTop || thumbnailTop + thumbnailHeight > scrollTop + sliderHeight) {
          this.slider.scrollTo({
            top: thumbnailTop - (sliderHeight / 2) + (thumbnailHeight / 2),
            behavior: 'smooth'
          });
        }
      }
    }
  );
}

// Extend media-gallery to support vertical thumbnails
document.addEventListener('DOMContentLoaded', () => {
  const verticalGalleries = document.querySelectorAll('.media-gallery--vertical-thumbnails');
  
  verticalGalleries.forEach(gallery => {
    const thumbnailSlider = gallery.querySelector('.thumbnail-slider--vertical');
    if (!thumbnailSlider) return;
    
    // Convert to custom element
    const thumbnailList = thumbnailSlider.querySelector('.thumbnail-list--vertical');
    const prevBtn = thumbnailSlider.querySelector('.slider-button--prev');
    const nextBtn = thumbnailSlider.querySelector('.slider-button--next');
    
    if (!thumbnailList) return;
    
    const scrollAmount = 100;
    
    // Scroll functions
    const scrollUp = (e) => {
      e.preventDefault();
      thumbnailList.scrollBy({ top: -scrollAmount, behavior: 'smooth' });
    };
    
    const scrollDown = (e) => {
      e.preventDefault();
      thumbnailList.scrollBy({ top: scrollAmount, behavior: 'smooth' });
    };
    
    const updateButtons = () => {
      const atTop = thumbnailList.scrollTop <= 0;
      const atBottom = thumbnailList.scrollTop + thumbnailList.clientHeight >= thumbnailList.scrollHeight - 1;
      
      if (prevBtn) prevBtn.style.display = atTop ? 'none' : 'flex';
      if (nextBtn) nextBtn.style.display = atBottom ? 'none' : 'flex';
    };
    
    if (prevBtn) prevBtn.addEventListener('click', scrollUp);
    if (nextBtn) nextBtn.addEventListener('click', scrollDown);
    thumbnailList.addEventListener('scroll', updateButtons);
    
    // Initial state
    updateButtons();
    
    // Show/hide buttons on hover
    thumbnailSlider.addEventListener('mouseenter', () => {
      const atTop = thumbnailList.scrollTop <= 0;
      const atBottom = thumbnailList.scrollTop + thumbnailList.clientHeight >= thumbnailList.scrollHeight - 1;
      
      if (prevBtn && !atTop) prevBtn.style.opacity = '1';
      if (nextBtn && !atBottom) nextBtn.style.opacity = '1';
    });
    
    thumbnailSlider.addEventListener('mouseleave', () => {
      if (prevBtn) prevBtn.style.opacity = '0';
      if (nextBtn) nextBtn.style.opacity = '0';
    });
  });
});

